(() => {
  if (window.p01NavigationReady) return;
  window.p01NavigationReady = true;
  const instances = new Map();
  function mount(header) {
    if (instances.has(header)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const scrollRoot = document.documentElement.classList.contains('p01-home') ? window : document.querySelector('.page-wrapper');
    const updateScrolled = () => header.classList.toggle('is-scrolled', Math.max(window.scrollY, scrollRoot?.scrollTop || 0) > 12);
    window.addEventListener('scroll', updateScrolled, { ...options, passive: true });
    if (scrollRoot && scrollRoot !== window) scrollRoot.addEventListener('scroll', updateScrolled, { ...options, passive: true });
    updateScrolled();
    const menu = header.querySelector('[data-p01-menu]');
    const trigger = menu?.querySelector('summary');
    const close = (focus = true) => { if (menu?.open) { menu.open = false; if (focus) trigger.focus(); } };
    const closeButton = header.querySelector('[data-p01-close-menu]');
    if (closeButton) { closeButton.hidden = false; closeButton.addEventListener('click', () => close(), options); }
    header.addEventListener('keydown', event => { if (event.key === 'Escape' && menu?.open) { event.preventDefault(); close(); } }, options);
    document.addEventListener('click', event => { if (menu?.open && !header.contains(event.target)) close(false); }, options);
    header.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.matches('[data-p01-header-cart]')) {
        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !location.pathname.endsWith('/cart')) {
          event.preventDefault(); close(false); drawer.open(); return;
        }
      }
      if (menu?.contains(link)) close(false);
    }, options);
    const large = matchMedia('(min-width:1100px)');
    large.addEventListener('change', () => { if (large.matches) close(false); }, options);
    instances.set(header, () => abort.abort());
  }
  const scan = root => { if (root.matches?.('[data-p01-header]')) mount(root); root.querySelectorAll?.('[data-p01-header]').forEach(mount); };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of instances) if (event.target.contains(root)) { dispose(); instances.delete(root); } });
})();
